import { Grid, Typography } from "@mui/material";
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { useTranslation } from "react-i18next";
import { AppStyle } from "../../helpers/appStyle";
import { appStyleMode } from "../../helpers/clientConfigs";

export function EmptyGoodsList() {
    const { t } = useTranslation('services');

    return (
        <Grid container
            sx={{
                my: "10px",
                height: appStyleMode !== AppStyle.Mobile && "600px",
                backgroundColor: "white",
                borderRadius: "15px"
            }}
            justifyContent="center"
            alignItems="center"
            direction="column">
            <Typography sx={{ fontSize: "20px", color: "gray" }}>{t('emptyGoodsList')}</Typography>
            <SentimentDissatisfiedIcon sx={{ color: "gray", height: "100px", width: "100px" }} />
        </Grid>
    );
}